import { Collapse } from 'antd';
import parse from 'html-react-parser';
import React, { useState } from 'react';
import { BsDash } from 'react-icons/bs';
import LinkButton from '../../../../common/LinkButton';
import { FAQ } from '../../../../utils/FAQ';
import { common_container } from './TopCard';

const { Panel } = Collapse;
interface props {
    isViewALl?: boolean;
    defaultOpen?: string[];
}
const DealsFAQ: React.FC<props> = ({ isViewALl = false, defaultOpen = ['1'] }) => {
    const [isActive, setIsActive] = useState('GENERAL');
    const customExpandIcon = (panelProps: { isActive?: boolean; onTrigger?: () => void }) => {
        const iconClasses = `custom-collapse-icon transition-transform duration-300 ease-in-out ${
            panelProps.isActive ? 'rotate-90' : ''
        }`;
        return (
            <span className={iconClasses} onClick={panelProps.onTrigger}>
                {panelProps.isActive ? <BsDash size={'1rem'} className="rotate-90" /> : <BsDash size={'1rem'} />}
            </span>
        );
    };
    return (
        <div className={`py-8`}>
            <div className={`${common_container} `}>
                <p className="font-[WorkSans-Semibold] uppercase mb-3 font-bold text-[26px] md:text-[30px] lg:text-[40px] text-[#20222B]">
                    Frequently Asked Questions
                </p>
                <div className="flex relative justify-end flex-col md:flex-row">
                    <div className="w-full md:w-1/3">
                        {FAQ.map((f, index) => (
                            <div
                                key={index}
                                className={`pl-4 my-6 border-l-2 ${
                                    isActive === f.title ? 'border-l-[#27AE60]' : 'border-l-[#D9D9D9]'
                                }`}
                            >
                                <label
                                    className={`text-2xl cursor-pointer ${
                                        isActive === f.title ? 'text-[#000000]' : 'text-[#D9D9D9]'
                                    }`}
                                    onClick={() => setIsActive(f.title)}
                                >
                                    {f.title}
                                </label>
                            </div>
                        ))}
                    </div>
                    {/* <div className="w-full md:w-60 md:h-60 md:absolute md:-left-4 flex justify-center items-center">
                        <img src={faqIcon} alt="fqa" className="hidden md:block" />
                        <img src={faqMIcon} alt="faq" className="block md:hidden" />
                        <p className="absolute text-base md:text-base left-4 md:w-48 mx-2 font-[Lato-Semibold] text-white font-semibold">
                            Lorem ipsum dolor sit amet consectetur. Pellentesque sagittis pellentesque volutpat.
                        </p>
                    </div> */}
                    <div className="w-full md:w-2/3 bg-white px-4 py-4 min-h-[18rem]">
                        <Collapse
                            bordered={false}
                            className="deals_faq bg-white font-[WorkSans-Semibold]"
                            defaultActiveKey={defaultOpen}
                            expandIconPosition="end"
                            expandIcon={customExpandIcon}
                        >
                            {FAQ.map((f, index) => (
                                // <Panel
                                //     header={<span className="font-[WorkSans-Semibold] font-semibold">{f.title}</span>}
                                //
                                // >
                                <div key={index + f.title}>
                                    {isActive === f.title && (
                                        <Collapse
                                            bordered={false}
                                            expandIconPosition="end"
                                            className="bg-white"
                                            expandIcon={customExpandIcon}
                                        >
                                            {f.list.map((l, index1) => (
                                                <Panel
                                                    // header={`${String(index1 + 1).padStart(2, '0')} ${l.title}`}
                                                    header={
                                                        <div className="flex gap-1 font-[WorkSans-Semibold]">
                                                            <p className="mr-4">
                                                                {String(index1 + 1).padStart(2, '0')}
                                                            </p>
                                                            <span className="">{l.title}</span>
                                                        </div>
                                                    }
                                                    key={`${index + 1}${index1}`}
                                                >
                                                    <div className="font-[WorkSans]"> {parse(l.description)}</div>
                                                </Panel>
                                            ))}
                                        </Collapse>
                                    )}
                                </div>
                                // </Panel>
                            ))}
                        </Collapse>
                    </div>
                </div>
                {isViewALl ? (
                    <div className="flex justify-start  py-8">
                        {/* <a
                            className="flex text-white cursor-pointer"
                            href={`/faq`}
                            target="_blank"
                            rel="noreferrer"
                        >
                            <p className="font-[WorkSans] font-bold text-base text-[#20222B] flex cursor-pointer uppercase">

                                <LuArrowUpRight
                                    className="ml-1 relative cursor-pointer"
                                    size={'1.6rem'}
                                    color="#41D17E"
                                />
                            </p>
                        </a> */}
                        <LinkButton
                            title={'View All'}
                            size="lg"
                            onClick={() => {
                                window.location.href = '/faq';
                            }}
                            isArrow={true}
                        />
                    </div>
                ) : null}
            </div>
        </div>
    );
};

export default DealsFAQ;
